import React from 'react';
import styled from '@emotion/styled';
import FilledInfoIcon from '../icons/FilledInfoIcon';
import StatusBarWrapper from './StatusBarWrapper';

const IncompleteStatusBarWrapper = styled(StatusBarWrapper)`
  background-color: #ef9d00;
`;

export const IncompleteStatusBar = () => {
  return (
    <IncompleteStatusBarWrapper data-testid="incomplete-status-bar">
      <FilledInfoIcon />
      <p>This project is incomplete.</p>
    </IncompleteStatusBarWrapper>
  );
};

export default IncompleteStatusBar;
